const receiptTaxSummaryDirective = function () {
    return {
        restrict: 'E',
        scope: {
            taxSummary: '=',
            hideTotalQty: '=',
        },
        templateUrl: 'partials/directives/dt-receipt-tax-summary.html',
        controller: function () {
        },
    };
};

module.exports = receiptTaxSummaryDirective;
